import type { JsonLdNode } from './types'

const JSON_LD_SCRIPT = /<script[^>]*type=["']application\/ld\+json["'][^>]*>([\s\S]*?)<\/script>/gi

/**
 * The schema.org blocks authored inside CMS HTML (AI-generated pages ship their own
 * Organization/WebPage/FAQPage graph). The HTML sanitizer drops every `<script>`, so they are
 * pulled out here and re-rendered through `JsonLd`; blocks that aren't valid JSON are skipped.
 */
export const extractJsonLd = (html: string | null | undefined): JsonLdNode[] =>
  [...(html ?? '').matchAll(JSON_LD_SCRIPT)].flatMap(([, json]) => {
    try {
      const node: unknown = JSON.parse(json)

      return node && typeof node === 'object' && !Array.isArray(node) ? [node as JsonLdNode] : []
    } catch {
      return []
    }
  })
